import React from 'react'
import { Button, Td, TFoot, TRow } from '@tecsinapse/cortex-react'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import { Table } from '@tanstack/react-table'
import { Select } from './select'
import { Trans } from '@lingui/react/macro'
import { t } from '@lingui/core/macro'

interface FooterProps<T> {
  table: Table<T>
  rowsPerPageOptions: number[]
  loading: boolean
  countList: number
}

export const Footer = <T,>({
  table,
  loading,
  rowsPerPageOptions,
  countList
}: FooterProps<T>) => {
  const page = table.getState().pagination.pageIndex
  const rowsPerPage = table.getState().pagination.pageSize

  const currentInitItem = page * rowsPerPage + 1
  const currentFinalItem =
    (page + 1) * rowsPerPage > countList ? countList : (page + 1) * rowsPerPage

  if (loading || countList === 0 || table.getRowModel().rows.length === 0) {
    return <></>
  }

  return (
    <TFoot>
      <TRow>
        <Td colSpan={table.getAllColumns().length}>
          <div
            className={'mt-centi flex justify-between items-center gap-x-deca'}
          >
            <div className='min-w-[25%]'>
              <Select
                value={table.getState().pagination.pageSize}
                keyExtractor={s => String(s)}
                labelExtractor={s => t`${s} itens`}
                onSelect={(e: number) => {
                  table.setPageSize(Number(e))
                }}
                label={t`Exibir por página`}
                options={rowsPerPageOptions}
              />
            </div>

            {!loading ? (
              <p className={'text-secondary-medium font-bold text-base'}>
                <Trans>
                  Mostrando {currentInitItem} a {currentFinalItem} de{' '}
                  {countList} registros
                </Trans>
              </p>
            ) : (
              <></>
            )}
            <div className={'flex items-center space-x-deca'}>
              <Button
                type='button'
                disabled={table.getState().pagination.pageIndex === 0}
                onClick={table.previousPage}
                variants={{ size: 'square' }}
              >
                <IoIosArrowBack />
              </Button>
              <Button
                type='button'
                disabled={
                  table.getState().pagination.pageIndex ===
                  Math.ceil(countList / rowsPerPage) - 1
                }
                onClick={table.nextPage}
                variants={{ size: 'square' }}
              >
                <IoIosArrowForward />
              </Button>
            </div>
          </div>
        </Td>
      </TRow>
    </TFoot>
  )
}
